<template>
  <div class="modal-container clearfix">
    <div class="container-top">
      <div class="download">
        <img src="@/assets/images/common/export.png"/>
        <span class="download-wz">下载模板，根据字段批量录入信息</span>
        <Button class="download-btn" @click="exportTemp">下载模板</Button>
      </div>
      <div class="import">
        <img src="@/assets/images/common/import.png"/>
        <span class="import-wz">将录入信息的Excel表格上传</span>
        <Button class="import-btn" @click="goImport">开始上传</Button>
      </div>
    </div>
    <div class="container-center1">
      <span class="title-czbz">操作步骤<br/></span>
      <span class="content-czbz">1. 点击【下载模板】，将含有明细字段的模板下载至本地，根据第一行表单字段名称录入内容信息<br/>
            2. 将录入信息的Excel表格确认无误后点击【选择文件】上传</span>
    </div>
    <div class="container-center2">
      <span class="title-zysx">注意事项<br/></span>
      <span class="content-zysx">1. 导入模板中第一行为表单字段名称不能删除或更改位置，从第二行开始填写需要导入的数据，若表格存在已填写的样例数据或有其它备注内容需要先删除<br/>
        2. <span style="color: red">*</span>为必填内容，单次导入的数据最好不要超过300条<br/>
            3. 导入的<span style="color: red">数据不能带空格、公式或其它异常字符</span>（最好为文本格式）。如 <span style="color: red">日期格式为：2021-01-01</span>，需要按照格式填写；涉及下拉选项的内容，导入时需要与系统创建下拉的内容一致填写，否则数据无法被系统识别<br/>
            <span v-if="tempName.indexOf('客户')>-1">4.名称默认取姓名或企业名称字段方便识别，若系统提示客户名称存在，说明已经存重名的客户，此时填写客户名称时需要用姓名+其他内容，方便区分。如：张三0098</span>
      </span>
    </div>
    <div class="modal-footer add-btn-box">
      <Button @click="cancel">取 消</Button>
    </div>
  </div>
</template>

<script>
  import {getExportModel} from "@/utils/util";

  export default {
    name: "Import",
    data() {
      return {
        tempName: '',
        dictCode: '',
        url :""
      };
    },
    created() {

    },
    methods: {
      cancel() {
        this.$emit('close');
      },
      goImport() {
        this.$emit('goImport');
      },
      setExport(tempName, dictCode, url) {
        this.tempName = tempName;
        this.dictCode = dictCode;
        this.url = url
      },
      async exportTemp() {
        //导出模版  
        let url = "/file/" + this.tempName
        if(this.url != null && this.url != ''){
          url = this.url
        }
        if(url != ''){
          this.downloadFile(url);
        }else{
          this.$XModal.message('没有配置模板文件')
        }
      },
      downloadFile(url) {
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        document.body.appendChild(link)
        link.click()
      },
    }
  };
</script>

<style>
  .container-top {
    display: flex;
    min-height: 259px;
    width: 100%;
  }

  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .download {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .download img {
    height: 84px;
    width: 84px;
  }

  .download-wz {
    text-align: center;
    margin-top: 5px;
    width: 240px;
    height: 21px;
    font-size: 16px;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    line-height: 21px;
    color: #C5C8CE;
    opacity: 1;
  }

  .download-btn {
    margin-top: 23px;
    width: 154px;
    height: 44px;
    color: #2D8CF0;
    border: 1px solid #5CADFF;
  }

  .import {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .import img {
    height: 84px;
    width: 84px;
  }

  .import-wz {
    text-align: center;
    margin-top: 5px;
    width: 240px;
    height: 21px;
    font-size: 16px;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    line-height: 21px;
    color: #C5C8CE;
    opacity: 1;
  }

  .import-btn {
    margin-top: 23px;
    width: 154px;
    height: 44px;
    color: #FFFFFF;
    background: #2D8CF0;
  }

  .container-center1 {
    border-top: 1px solid #EEEEEE;
    padding: 12px 14px 0 14px;
    min-height: 97px;
    width: 100%;
  }

  .container-center2 {
    border-top: 1px solid #EEEEEE;
    padding: 12px 14px 0 14px;
    min-height: 178px;
    width: 100%;
  }

  .title-czbz {
    width: 64px;
    height: 21px;
    font-size: 16px;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    line-height: 21px;
    color: #666666;
    opacity: 1;
  }

  .content-czbz {
    margin-top: 12px;
    width: 952px;
    height: 40px;
    font-size: 12px;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    line-height: 23px;
    color: #999999;
    opacity: 1;
  }

  .title-zysx {
    width: 64px;
    height: 21px;
    font-size: 16px;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    line-height: 21px;
    color: #666666;
    opacity: 1;
  }

  .content-zysx {
    width: 952px;
    height: 110px;
    font-size: 12px;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    line-height: 23px;
    color: #999999;
    opacity: 1;
  }
</style>